import type { ModuleDefinition } from "../types";
import { DINING_READ, EVENTS_READ } from "./permissions";

const screens = () => import("./screens");

/** Events and dining reservations, for staff. The member side lives in the member portal. */
export const eventsModule: ModuleDefinition = {
  id: "events",
  labelKey: "module.events",
  nav: [
    { id: "events", labelKey: "events.nav.events", to: "/events", icon: "calendar", permission: EVENTS_READ, end: true },
    { id: "spaces", labelKey: "events.nav.spaces", to: "/events/spaces", icon: "building", permission: EVENTS_READ },
    { id: "setup", labelKey: "events.nav.setup", to: "/events/setup", icon: "sliders", permission: EVENTS_READ },
    { id: "dining", labelKey: "events.nav.dining", to: "/dining", icon: "clock", permission: DINING_READ, end: true },
    { id: "dining-requests", labelKey: "events.nav.diningRequests", to: "/dining/requests", icon: "flag", permission: DINING_READ },
    { id: "dining-setup", labelKey: "events.nav.diningSetup", to: "/dining/setup", icon: "sliders", permission: DINING_READ },
  ],
  routes: [
    { path: "events", permission: EVENTS_READ, load: async () => ({ default: (await screens()).EventsPage }) },
    { path: "events/spaces", permission: EVENTS_READ, load: async () => ({ default: (await screens()).SpacesPage }) },
    { path: "events/setup", permission: EVENTS_READ, load: async () => ({ default: (await screens()).SetupPage }) },
    { path: "events/:eventId", permission: EVENTS_READ, load: async () => ({ default: (await screens()).EventPage }) },
    { path: "dining", permission: DINING_READ, load: async () => ({ default: (await screens()).DiningPage }) },
    { path: "dining/requests", permission: DINING_READ, load: async () => ({ default: (await screens()).DiningRequestsPage }) },
    { path: "dining/setup", permission: DINING_READ, load: async () => ({ default: (await screens()).DiningSetupPage }) },
    { path: "dining/reservations/:reservationId", permission: DINING_READ, load: async () => ({ default: (await screens()).ReservationRedirect }) },
  ],
};
